/** RN36: manutenção dos prazos mínimos e do calendário de feriados — só a UABS (HOSPEDAGEM-24). */
const menuPrazos = {
    label: 'Prazos de hospedagem',
    icon: 'pi pi-fw pi-calendar',
    to: '/solicitacoes/hospedagem/prazos-contratacao',
    rules: ['HOSPEDAGEM-24'],
};

export default menuPrazos;
